import { Box } from '@mui/material'
import React, { useEffect, useLayoutEffect, useRef, useState } from 'react'
import { filter, IconCross, IconFilterChips } from '../../../../assets/images/icons'
import {
  BlockingLoader,
  NoDataFound,
  ReportHeading,
  ToolTip,
  VerbatimImageVideoGrid,
  Legend,
  Loader,
  MuiButton,
} from '../../../../components'
import ReportsService from '../../../../services/reports.service'
import { useGlobalStore } from '../../../../store'
import ReportVerbatim from '../reportVerbatim'
import DownloadExcel from './downloadExcel'
import Fitlers from './filters'
import { ROLES_CLIENT_SECONDARY, ROLES_MM_SECONDARY } from '../../../../constants'
import { useLocation, useHistory } from 'react-router-dom'

import {
  Wrapper,
  ContentWrapper,
  LeftGrid,
  RightGrid,
  ReportSandboxWrap,
  InfoToolTipWrap,
  FiltersWrap,
  LegendWrapper,
  VerbatimImageVideoWrapper,
  DisplayChipsWrapper,
  ChipsItem,
  AdvanceWrapper,
  FilterChip,
} from './style'
import AdvanceSearch from './advanceSearch'

const ReportSandbox = (props) => {
  const excelRef = useRef()
  const { user, projectIdValue } = useGlobalStore()
  const [state, setState] = useState([])
  const [filters, setFilters] = useState(null)
  const [isLoading, setLoading] = useState(false)
  const history = useHistory()
  const location = useLocation()
  const queryString = location.search
  const params = new URLSearchParams(queryString)
  const parseRow = () => {
    const params = new URLSearchParams(location.search)
    const parsedRows = []

    Array.from(params.entries()).forEach(([key, value], index) => {
      if (key.startsWith('match')) {
        const [text = '', matchType = '', sources = ''] = value.split('~')

        let verbatim = false
        let metadata = false

        if (sources === 'both') {
          verbatim = true
          metadata = true
        } else {
          const sourceList = sources.split('|')
          verbatim = sourceList.includes('verbatim')
          metadata = sourceList.includes('metadata')
        }

        parsedRows.push({
          id: key, // or use a unique index if you prefer
          text,
          matchType,
          verbatim,
          metadata,
          showError: false,
          matchTypeSelected: true,
        })
      }
    })

    return parsedRows
  }

  const verbatimParam = params.get('verbatim')
  const metadataParam = params.get('metadata')

  const isVerbatim =
    verbatimParam === null && metadataParam === null ? true : verbatimParam === 'true'

  const isMetadata =
    verbatimParam === null && metadataParam === null ? true : metadataParam === 'true'

  const [filterData, setFilterData] = useState({
    insightsElementId: props.InsightsElementId,
    entityName: params.get('entityName') || '',
    driverName: params.get('driverName') || '',
    attributeName: params.get('attributeName') || '',
    searchText: params.get('searchText') || '',
    rows: parseRow() || [],
    verbatim: isVerbatim,
    metadata: isMetadata,
  })
  // filterData?.verbatim ||
  // filterData?.metadata ||
  const [chipData, setChipData] = useState(null)
  const [rows, setRows] = useState(
    parseRow() || [
      {
        id: 1,
        text: '',
        matchType: '',
        verbatim: true,
        metadata: true,
        showError: false,
        matchTypeSelected: false,
      },
    ]
  )

  // const [advanceSearchKey, setAdvanceSearchKey] = useState(null);

  const gotoView = () => {
    const ele = document.querySelector('.Information')
    if (ele) {
      ele.scrollTo(0, 0)
    }
  }

  const handleDeleteAppliedItem = (type, idOrValue) => {
    let obj = {}

    if (filterData) {
      obj = { ...filterData }

      if (type === 'rows') {
        const newRows = (obj.rows = obj.rows.filter((row) => row.id !== idOrValue))
        setRows(newRows)
      } else {
        obj[type] = ''
      }

      if (obj.entityName !== params.get('entityName')) {
        obj.entityName = ''
      }
      if (obj.driverName !== params.get('driverName')) {
        obj.driverName = ''
      }
      if (obj.attributeName !== params.get('attributeName')) {
        obj.attributeName = ''
      }
      if (obj.searchText !== params.get('searchText')) {
        obj.searchText = ''
      }

      setFilterData(obj)

      setChipData({ ...obj })
      // setAppliedFilters(obj)

      // setIsDeleteTriggered(true)

      getSandboxVerbatimElementWithSearch(obj)
      updateQueryString(obj)

      if (
        obj?.rows.length === 0 &&
        obj?.attributeName === '' &&
        obj?.driverName === '' &&
        obj?.entityName === '' &&
        obj?.searchText === ''
      ) {
        handleReset()
      }
    }
  }

  const handleReset = () => {
    const resetData = {
      insightsElementId: props.InsightsElementId,
      entityName: '',
      driverName: '',
      attributeName: '',
      searchText: '',
      rows: [],
      verbatim: true,
      metadata: true,
    }
    setChipData('')
    setFilterData(resetData)
    handleSubmit(resetData)
    // getSandboxVerbatimElementWithSearch(resetData);
  }

  const handleChipClearAll = () => {
    const resetData = {
      insightsElementId: props.InsightsElementId,
      entityName: '',
      driverName: '',
      attributeName: '',
      searchText: '',
      rows: [],
      verbatim: true,
      metadata: true,
    }
    setRows([
      {
        id: 1,
        text: '',
        matchType: '',
        verbatim: true,
        metadata: true,
        showError: false,
        matchTypeSelected: false,
      },
    ])
    setChipData('')
    setFilterData(resetData)
    handleSubmit(resetData)
    getSandboxVerbatimElementWithSearch(resetData)
  }

  const updateQueryString = (obj) => {
    // Create a new URLSearchParams object based on the current location's search string
    const searchParams = new URLSearchParams()

    // Set or update the 'search' query parameter
    if (obj?.entityName) searchParams.set('entityName', obj.entityName)
    if (obj?.driverName) searchParams.set('driverName', obj.driverName)
    if (obj?.attributeName) searchParams.set('attributeName', obj.attributeName)
    if (obj?.searchText) searchParams.set('searchText', obj.searchText)
    if (obj?.verbatim) searchParams.set('verbatim', obj.verbatim)
    if (obj?.metadata) searchParams.set('metadata', obj.metadata)

    if (obj?.rows && Array.isArray(obj.rows)) {
      obj.rows.forEach((row) => {
        if (!row.text?.trim()) return

        let source = ''
        if (row.verbatim && row.metadata) {
          source = 'both'
        } else if (row.verbatim) {
          source = 'verbatim'
        } else if (row.metadata) {
          source = 'metadata'
        }

        if (source) {
          const value = `${row.text}~${row.matchType}~${source}`
          const matchKey = String(row.id).startsWith('match') ? row.id : `match${row.id}`
          searchParams.set(matchKey, value)
        }
      })
    }

    // Use history.push() to navigate with the updated query string
    history.push({
      pathname: location.pathname,
      search: searchParams.toString(),
    })
  }

  const handleSubmit = (obj) => {
    updateQueryString(obj)
    getSandboxVerbatimElementWithSearch(obj)
  }

  const getSandboxVerbatimElementWithSearch = async (data = null) => {
    const filterPayload = data || filterData

    const includeTerm =
      filterPayload?.rows
        ?.filter((row) => row.matchType === 'and')
        ?.map((row) => ({
          MetadataVerbatimTerm: {
            SearchMetadata: row.metadata,
            SearchVerbatim: row.verbatim,
            Term: encodeURI(row.text.trim() || ''),
          },
        })) || []

    const excludeTerm =
      filterPayload?.rows
        ?.filter((row) => row.matchType === 'not')
        ?.map((row) => ({
          MetadataVerbatimTerm: {
            SearchMetadata: row.metadata,
            SearchVerbatim: row.verbatim,
            Term: encodeURI(row.text.trim() || ''),
          },
        })) || []

    if (filterPayload?.searchText?.trim()) {
      includeTerm.unshift({
        MetadataVerbatimTerm: {
          SearchMetadata: filterPayload?.metadata,
          SearchVerbatim: filterPayload?.verbatim,
          Term: encodeURI(filterPayload.searchText.trim() || ''),
        },
      })
    }

    // Object Created with new payload
    const newPayloadObjectTwo = {
      insightsElementId: filterPayload.insightsElementId,
      entityName: filterPayload.entityName,
      driverName: filterPayload.driverName,
      attributeName: filterPayload.attributeName,
      includeTerms: includeTerm,
      excludeTerms: excludeTerm,
      // searchText: filterPayload.searchText,
    }

    const method = filterPayload?.searchText?.trim()
      ? ReportsService.getSandboxVerbatimElementWithSearch
      : ReportsService.getSandboxVerbatimElement

    const method1 = ReportsService.getSandboxVerbatimElementWithAdvancedSearch

    try {
      setLoading(true)
      setFilters({ ...filterPayload, searchText: filterPayload?.searchText || '' })

      console.log(newPayloadObjectTwo)

      // const resp = await method1(filterPayload, true)
      const resp = await method1(newPayloadObjectTwo, true)
      const mp4 = resp.filter((f) => f.VerbatimMediaPrivateName.indexOf('.mp4') !== -1)

      // console.log("resp", resp.length, newPayloadObjectTwo)
      setState(resp || [])
      gotoView()
    } catch (error) {
    } finally {
      setLoading(false)
    }
  }

  const legendsArray = [
    { label: 'Positive', value: 'Positive' },
    { label: 'Neutral', value: 'Neutral' },
    { label: 'Mixed', value: 'Mixed' },
    { label: 'Negative', value: 'Negative' },
  ]

  const handleSearchApply = (data) => {
    setFilterData(data)
    getSandboxVerbatimElementWithSearch(data)
    // setAdvanceSearchKey(data);
  }

  // const filtersChanged = () => {
  //   setAdvanceSearchKey(filterData);
  // }

  useEffect(() => {
    if (props?.InsightsElementId) {
      getSandboxVerbatimElementWithSearch()
      if (
        filterData.attributeName === '' &&
        filterData.driverName === '' &&
        filterData.entityName === '' &&
        filterData.searchText === '' &&
        (filterData.rows.length === 0 ||
          (filterData.rows?.length === 1 && filterData.rows[0]?.text === ''))
      ) {
        setChipData(false)
      } else {
        setChipData(filterData)
      }
    }
  }, [])

  // useLayoutEffect(() => {
  //   const queryString = location.search
  //   const params = new URLSearchParams(queryString)

  //   const obj = {
  //     entityName: params.get('entityName') || '',
  //     driverName: params.get('driverName') || '',
  //     attributeName: params.get('attributeName') || '',
  //     searchText: params.get('searchText') || '',
  //     rows: [],
  //     verbatim: true,
  //     metadata: true,
  //   }
  //   // setFilters(obj)
  //   setFilterData({ ...obj, insightsElementId: props?.insightsElementId })
  // }, [])

  return (
    <Wrapper>
      <ReportHeading
        afterHeadingComponent={<InfoToolTip />}
        additionalButton={
          ROLES_CLIENT_SECONDARY.includes(user.UserType) && (
            <DownloadExcel data={state} breadCrumb={filters} />
          )
        }
        additionalMiddleButton={
          ROLES_MM_SECONDARY.includes(user.UserType) &&
          !projectIdValue?.IsFreezed && <ReportVerbatim {...props} />
        }
        subHeading=''
        {...props}
      />
      <ContentWrapper>
        <ReportSandboxWrap>
          <LeftGrid>
            <FiltersWrap>
              {filterData && (
                <Fitlers
                  type='showAll'
                  setFilteredData={setFilterData}
                  filteredData={filterData}
                  insightsElementId={props.InsightsElementId}
                  onFilterChange={handleSubmit}
                  updateChips={setChipData}
                  parsedRows={parseRow}
                  // filterChange={filtersChanged}
                />
              )}
            </FiltersWrap>
          </LeftGrid>
          {/* filterData={advanceSearchKey} */}

          <AdvanceWrapper>
            <FilterChip>{chipData && <IconFilterChips />}</FilterChip>
            <DisplayChipsWrapper>
              {chipData && (
                <>
                  {/* {filterData || props.filterData && (<IconFilterChips/>)} */}

                  {/* Replaced x with the icon */}
                  {/* {(filterData?.verbatim && !filterData?.metadata) && (
                    <ChipsItem>
                      <strong>Search In:{'\u00A0'}</strong>Verbatim
                      <span onClick={() => handleDeleteAppliedItem('verbatim')} ><IconCross /></span>
                    </ChipsItem>
                  )}
    
                  {(!filterData?.verbatim && filterData?.metadata) && (
                    <ChipsItem>
                    <strong>Search In:{'\u00A0'}</strong>Metadata
                    <span onClick={() => handleDeleteAppliedItem('metadata')} ><IconCross /></span>
                    </ChipsItem>
                  )}   */}

                  {chipData?.entityName && (
                    <ChipsItem title={chipData?.entityName}>
                      <strong>Brand/Category:{'\u00A0'}</strong>
                      {chipData?.entityName}
                      <span onClick={() => handleDeleteAppliedItem('entityName')}>
                        <IconCross />
                      </span>
                    </ChipsItem>
                  )}
                  {/* {filterData?.entityName || props.filterData?.entityName && (
                    <ChipsItem>
                    <strong>Entity:{'\u00A0'}</strong>{filterData?.entityName ?? props.filterData?.entityName}
                      <span onClick={() => handleDeleteAppliedItem('entityName')} ><IconCross /></span>
                    </ChipsItem>
                  )} */}

                  {chipData?.driverName && (
                    <ChipsItem title={chipData?.driverName}>
                      <strong>Driver:{'\u00A0'}</strong>
                      {chipData?.driverName}
                      <span onClick={() => handleDeleteAppliedItem('driverName')}>
                        <IconCross />
                      </span>
                    </ChipsItem>
                  )}
                  {/* {filterData?.driverName || props.filterData?.driverName && (
                    <ChipsItem>
                    <strong>Driver:{'\u00A0'}</strong>{filterData?.driverName ?? props.filterData?.driverName}
                      <span onClick={() => handleDeleteAppliedItem('driverName')} ><IconCross /></span>
                    </ChipsItem>
                  )} */}

                  {chipData?.attributeName && (
                    <ChipsItem title={chipData?.attributeName}>
                      <strong>Attribute:{'\u00A0'}</strong>
                      {chipData?.attributeName}
                      <span onClick={() => handleDeleteAppliedItem('attributeName')}>
                        <IconCross />
                      </span>
                    </ChipsItem>
                  )}
                  {/* {filterData?.attributeName || props.filterData?.attributeName  && (
                    <ChipsItem>
                    <strong>Attribute:{'\u00A0'}</strong>{filterData?.attributeName ?? props.filterData?.attributeName}
                    <span onClick={() => handleDeleteAppliedItem('attributeName')} ><IconCross /></span>
                    </ChipsItem>
                  )} */}

                  {chipData?.searchText &&
                    (() => {
                      const hasText = chipData.searchText?.trim()

                      if (hasText === '') return null

                      const selectedCheckBox = []
                      if (chipData.verbatim) selectedCheckBox.push('Verbatim')
                      if (chipData.metadata) selectedCheckBox.push('Metadata')

                      const showCheckBox =
                        selectedCheckBox.length > 0 && selectedCheckBox.length < 2

                      return (
                        <ChipsItem title={chipData.searchText}>
                          <span className='text-truncate'>
                            {hasText && ` ${chipData.searchText}`}
                          </span>
                          {showCheckBox && ` (${selectedCheckBox[0]})`}
                          <span onClick={() => handleDeleteAppliedItem('searchText')}>
                            <IconCross />
                          </span>
                        </ChipsItem>
                      )
                    })()}

                  {/* {filterData?.searchText || props.filterData?.searchText && (
                  <ChipsItem>
                    {filterData?.searchText ?? props.filterData?.searchText}
                    <span onClick={() => handleDeleteAppliedItem('searchText')} ><IconCross /></span>
                  </ChipsItem>
                )} */}

                  {chipData?.rows?.map((row) => {
                    const hasText = row.text?.trim()
                    const hasCheckbox = row.verbatim || row.metadata

                    if (hasText === '') return

                    const isNotType = row.matchType === 'not'
                    const selectedCheckBox = []
                    if (row.verbatim) selectedCheckBox.push('Verbatim')
                    if (row.metadata) selectedCheckBox.push('Metadata')

                    const showCheckBox = selectedCheckBox.length > 0 && selectedCheckBox.length < 2

                    return (
                      <ChipsItem title={row.text} key={row.id}>
                        {isNotType && (
                          <strong style={{ fontSize: '12px', fontWeight: '600' }}>
                            Not:{'\u00A0'}
                          </strong>
                        )}
                        <span className='text-truncate'>{hasText && ` ${row.text}`}</span>
                        {showCheckBox && ` (${selectedCheckBox[0]})`}
                        <span onClick={() => handleDeleteAppliedItem('rows', row.id)}>
                          <IconCross />
                        </span>
                      </ChipsItem>
                    )
                  })}

                  {chipData && (
                    <MuiButton
                      variant='text'
                      size='small'
                      color='primary'
                      label='Clear All'
                      onClick={handleChipClearAll}
                    />
                  )}
                  {/* {filterData || props.filterData && (
                    <MuiButton variant='text' size='small' color='primary' label='Clear All' onClick={handleReset}/> 
                  )} */}
                </>
              )}
            </DisplayChipsWrapper>

            <AdvanceSearch
              parsedRows={parseRow}
              rows={rows}
              setRows={setRows}
              updateChips={setChipData}
              updateQuery={updateQueryString}
              resetApiCall={getSandboxVerbatimElementWithSearch}
              filterData={filterData}
              setFilterData={setFilterData}
              insightsElementId={props.InsightsElementId}
              onApplyFilters={handleSearchApply}
              onResetFilters={getSandboxVerbatimElementWithSearch}
            />
          </AdvanceWrapper>

          <RightGrid>
            {!isLoading && !!state.length && (
              <VerbatimImageVideoWrapper ref={excelRef} style={{ width: '100%' }}>
                <VerbatimImageVideoGrid
                  showEntityName
                  insightsElementId={props?.InsightsElementId}
                  data={[...state]}
                  entityType={props?.EntityType}
                />

                {!!state.length && (
                  <LegendWrapper>
                    <Legend legends={legendsArray} />
                  </LegendWrapper>
                )}
              </VerbatimImageVideoWrapper>
            )}
            {!isLoading && !state.length && <NoDataFound img={filter} title='Select Filter' />}
            {isLoading && !state.length && <Loader />}
          </RightGrid>
        </ReportSandboxWrap>
        {isLoading && <BlockingLoader />}
      </ContentWrapper>
    </Wrapper>
  )
}

export default ReportSandbox

const InfoToolTip = () => {
  return (
    <InfoToolTipWrap>
      <ToolTip
        sx={{
          width: '900px',
          '& .tooltip-wrap': {
            fontSize: '14px',
            fontWeight: '300 !important',
          },
        }}
      >
        Verbatim Insights provides access to a large sample of actual unedited consumer speak that
        are arrayed by sentiments and can be filtered by brands, drivers and attributes.
      </ToolTip>
    </InfoToolTipWrap>
  )
}
